import { UnifiedCameraCapture } from "@/components/ui/camera/UnifiedCameraCapture";

interface CameraCaptureProps {
  onCapture: (file: File) => void;
  onCancel: () => void;
}

export function CameraCapture({ onCapture, onCancel }: CameraCaptureProps) {
  return (
    <UnifiedCameraCapture
      onCapture={onCapture}
      onClose={onCancel}
    />
  );
}
